import { useEffect } from 'react';
import { FieldValues } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { setQueries } from 'redux/slices/query';

const useQueryParams = () => {
  const dispatch = useAppDispatch();
  const queries = useAppSelector((state) => state.queries.customerQueries);

  const [params, paramsSet] = useSearchParams();

  const setActiveQueries = (activeQueries: FieldValues) => {
    dispatch(setQueries(activeQueries));
    paramsSet(activeQueries);
  };

  useEffect(() => {
    if (queries) {
      paramsSet(queries);
    }
  }, []);

  return { params, setActiveQueries };
};

export { useQueryParams };
